import PropTypes from "prop-types"
import React from "react"

const Header = () => (
  <header className="section section--head">
    <div className="container">
      <ul className="nav-list">
        <li className="nav--link logo-left"></li>
      </ul>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

export default Header
